<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all overflow-y-auto w-2/3" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 70vh;">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-blue-900" id="modal-headline">
                Buscar Usuario
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                  <input type="text" placeholder="E-mail / Nombre y Apellido" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600" @keyup="search" v-model="query">
                </div>
                <table class="min-w-full" v-if="users.length > 0">
                    <thead>
                      <tr>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border border-blue-200 bg-blue-50"
                        >Usuario</th>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border border-blue-200 bg-blue-50"
                        >E-mail</th>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border border-blue-200 bg-blue-50"
                        >Estado</th>
                        <th 
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border border-blue-200 bg-blue-50">
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white">
                      <tr 
                        class="cursor-pointer"
                        @click="selectUser(u)"
                        v-for="u in users" :key="u.id">
                        <td
                          class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                        >
                          <div class="flex items-center">
                            <div class="flex-shrink-0 w-10 h-10">
                              <img
                                v-if="u.roles.length == 0"
                                class="w-8 h-8 rounded-full"
                                :src="require('../assets/images/noavatar.png')"
                                alt=""
                              />
                              <img
                                v-if="u.roles.length > 0"
                                class="w-8 h-8 rounded-full"
                                :src="require('../assets/images/user-happer.png')"
                                alt=""
                              />
                            </div>
                            <div class="ml-4">
                              <div class="text-sm font-medium leading-5 text-gray-900">
                                {{ u.person.name }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                        >
                          <div class="text-sm text-center leading-5 text-gray-500">
                            {{ u.email }}
                          </div>
                        </td>
                        <td
                          class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                        >
                          <span
                            v-if="u.active"
                            class="inline-flex px-3 py-1 text-sm font-semibold leading-5 text-green-800 bg-green-200 rounded-full"
                          >
                            Activo
                          </span>
                          <span
                            v-if="!u.active"
                            class="inline-flex px-3 py-1 text-sm font-semibold leading-5 text-red-800 bg-red-200 rounded-full"
                          >
                            Bloqueado
                          </span>
                        </td>
                        <td
                          class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                        >
                          <div class="flex flex-row-reverse">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-green-600"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                              </path>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="closeModal"
              type="button" 
              class="inline-flex justify-center bg-transparent hover:bg-red-500 text-xs text-red-700 font-semibold hover:text-white py-2 px-2 border border-red-500 hover:border-transparent rounded">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    modal: false
  },

  data() {
    return {
      loading: false,
      query: null,
      user: null,
      users: []
    }
  },

  watch: {
    modal (value) {
      if (value) {
        this.query = null
        this.users = []
        this.user = null
      }
    }
  },

  methods: {
    selectUser(user) {
      this.user = user
      this.closeModal()
    },
    closeModal() {
      this.$emit('closeModalUser', this.user)
    },
    async search() {
      if (this.query.length >= 3){
        this.user = null
        const response = await this.$http.get(`users/search/${this.query}`)
        this.users = response.data
      }
    }
  },
}
</script>

